export function isEventHandler(data:any){
    return typeof data === 'object' && data && data.type === 'EventHandler';
}